module.exports = __webpack_public_path__ + "img/zb.095900a9.png";